import React, { Fragment, useState, useEffect } from "react";
import man from "../../../assets/images/dashboard/user.png";
import {  LogOut } from "react-feather";
import { useNavigate } from "react-router-dom";

const UserMenu = () => {
  const [profile, setProfile] = useState("");
  const authenticated = JSON.parse(localStorage.getItem("authenticated"));
  const auth0_profile = JSON.parse(localStorage.getItem("auth0_profile"));
  const navigate = useNavigate();

  useEffect(() => {
    setProfile(localStorage.getItem("profileURL") || man);
  }, []);

  const Logout = () => {
    localStorage.removeItem("profileURL");
    localStorage.removeItem("token");
    localStorage.clear();

    navigate(`${process.env.PUBLIC_URL}/login`);
  };

  return (
    <Fragment>
      <li className="onhover-dropdown">
        <div className="d-flex align-items-center">
          <img className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded" src='/assets/images/download (6).png' alt="header-user" />
         
        </div>
        <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
          {/* <li>
            <Link to={${process.env.PUBLIC_URL}/users/userEdit}>
              <User />
              {EditProfile}
            </Link>
          </li> */}
        
      
          {/* <li>
            <Link to='/pages/settings'>
              <Settings />
              {"Settings"}
            </Link>
          </li> */}
          <li onClick={Logout}>
            {/* <a onClick={Logout} href="javascript:void(0)"> */}
              <LogOut /> {"Log out"}
            {/* </a> */}
          </li>
        </ul>
      </li>
    </Fragment>
  );
};

export default UserMenu;
